<template>
    <div class="bg">
        <b-row style="height: 100vh">
            <b-col sm="4" offset-sm="4">
                <b-card class="valign rounded">
                    <b-col md="12" style="text-align: center">
                        <img src="../assets/logo.png" height=90 width=90 />
                    </b-col>
                    <b-input-group class="mt-4">
                        <b-input-group-prepend is-text>
                            <font-awesome-icon class="fa-fw" icon="user" />
                        </b-input-group-prepend>
                        <b-input v-model="username" placeholder="Username"></b-input>
                    </b-input-group>
                    <b-input-group class="mt-2">
                        <b-input-group-prepend is-text>
                            <font-awesome-icon class="fa-fw" icon="key" />
                        </b-input-group-prepend>
                        <b-input v-model="password" type="password" placeholder="Password" @keyup.enter="didTapLogin"></b-input>
                    </b-input-group>
                    <b-form-text text-variant="danger" v-if="isFailure">Incorrect username / password combination!</b-form-text>
                    <b-btn class="mt-4 mb-4" block variant="primary" :disabled="isLoggingIn" @click="didTapLogin">
                        <b-spinner small v-if="isLoggingIn"></b-spinner>
                        <span v-else>Login</span>
                    </b-btn>
                    <b-form-text class="mt-4" style="text-align: center">Forgot your account credentials? Contact us at +62 888 8888888 or support@ptwespi.co.id to get your account reset.</b-form-text>
                </b-card>
            </b-col>
        </b-row>
        <b-modal id="modal-welcome" centered size="lg" hide-header
            ok-only ok-title="Login" no-close-on-backdrop no-close-on-esc
        >
            <b-row>
                <b-col md="2">
                    <img src="../assets/logo.png" height=90 width=90 />
                </b-col>
                <b-col>
                    <h3 class="mb-0">PT. WESTERN ELECTRIC SUBMERSIBLE PUMP INDONESIA</h3>
                    <h5 class="mb-0">Electric Submersible Pumping System Procurer</h5>
                    <hr />
                </b-col>
            </b-row>
            <div class="mt-4">
                <strong>PUMP SIZING CALCULATOR</strong><br />
                Copyright &copy; 2019 PT. WESP Indonesia
            </div>
            <div class="mt-4 text-right">
                Version {{ appVersion }}
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'login',
    data() {
        return {
            username: "",
            password: "",
            isLoggingIn: false,
            isFailure: false,
            appVersion: localStorage.getItem("appVersion") || "1.0.0"
        }
    },
    methods: {
        didTapLogin() {

            let payload = {
                username: this.username,
                password: this.password
            }

            this.isFailure = false
            this.isLoggingIn = true
            this.$axios.post("/auth/login", payload).then(response => {

                let res = response.data
                if(res.message == "OK") {

                    let data = res.data

                    // Access Token
                    localStorage.setItem("accessToken", data.token)
                    this.$axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`

                    localStorage.setItem("fullName", data.fullName)
                    localStorage.setItem("role", data.role)

                    this.$router.push("/dashboard")

                }
                else {
                    this.isFailure = true
                }

            })
            .catch(error => {
                this.isFailure = true
            })
            .finally(() => {
                this.isLoggingIn = false
            })

        }
    },
    created() {
        this.$nextTick(() => {
            this.$bvModal.show("modal-welcome")
        })
    }
}
</script>

<style scoped>
    .bg {
        height: 100vh;
        background: rgb(0,136,255);
        background: -moz-radial-gradient(circle, rgba(0,136,255,1) 0%, rgba(9,9,121,1) 40%, rgba(2,2,36,1) 100%);
        background: -webkit-radial-gradient(circle, rgba(0,136,255,1) 0%, rgba(9,9,121,1) 40%, rgba(2,2,36,1) 100%);
        background: radial-gradient(circle, rgba(0,136,255,1) 0%, rgba(9,9,121,1) 40%, rgba(2,2,36,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#0088ff",endColorstr="#020224",GradientType=1);
    }

    .valign {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>